module.exports = __webpack_public_path__ + "static/img/07.6ef1dc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/07.jpg
// module id = Qrzf
// module chunks = 1